module.exports = __webpack_public_path__ + "img/2015016.ce873056.svg";